import {dispatchStorageChange, subscribeToStorageKeys} from "../../../../search/utils/storage_change_event";

/*
 * A JSON value in localStorage that React can subscribe to (`useSyncExternalStore`). Other tabs are heard through the
 * native `storage` event, the current tab through RECENT_SEARCHES_CHANGED_EVENT (`storage_change_event`), which every
 * write dispatches.
 * Nothing here throws: no window (SSR), blocked storage, quota errors and broken JSON all read as the empty value.
 */

const getLocalStorage = (): Storage | null => (typeof window === "undefined" ? null : window.localStorage);

/** Keeps the items `parseItem` accepts, in order, at most `max` of them. Anything but an array gives []. */
export const parseStoredList = <TItem>(value: unknown, parseItem: (item: unknown) => TItem | null, max: number): TItem[] => {
    if (!Array.isArray(value)) {
        return [];
    }

    const items: TItem[] = [];

    for (const entry of value) {
        if (items.length >= max) {
            break;
        }

        const item = parseItem(entry);

        if (item !== null) {
            items.push(item);
        }
    }

    return items;
};

interface ILocalStorageListStoreOptions<TValue> {
    key: string;
    /** Validates the parsed JSON. Null means an unknown shape, which reads as `empty`. */
    parse: (value: unknown) => TValue | null;
    empty: TValue;
    /** Defaults to `window.localStorage`; null when there is no storage. */
    getStorage?: () => Storage | null;
}

interface ILocalStorageListStore<TValue> {
    readonly key: string;
    /** Current value. Returns the same reference while the stored string does not change, as `useSyncExternalStore` requires. */
    read: () => TValue;
    /** Stores the value and notifies same-tab subscribers. False when storage is unavailable or throws (quota, privacy mode). */
    write: (value: TValue) => boolean;
    /** Reads, applies `updater` and writes the result; an updater returning the same reference skips the write. */
    update: (updater: (current: TValue) => TValue) => boolean;
    remove: () => boolean;
    subscribe: (listener: () => void) => () => void;
}

export const createLocalStorageListStore = <TValue>(options: ILocalStorageListStoreOptions<TValue>): ILocalStorageListStore<TValue> => {
    const {key, parse, empty, getStorage = getLocalStorage} = options;

    let cachedRaw: string | null = null;
    let cachedValue: TValue = empty;

    const readRaw = (): string | null => {
        try {
            return getStorage()?.getItem(key) ?? null;
        } catch {
            return null;
        }
    };

    const read = (): TValue => {
        const raw = readRaw();

        if (raw === cachedRaw) {
            return cachedValue;
        }

        let value = empty;

        if (raw !== null) {
            try {
                value = parse(JSON.parse(raw)) ?? empty;
            } catch {
                value = empty;
            }
        }

        cachedRaw = raw;
        cachedValue = value;

        return value;
    };

    const write = (value: TValue): boolean => {
        try {
            const storage = getStorage();

            if (!storage) {
                return false;
            }

            storage.setItem(key, JSON.stringify(value));
        } catch {
            return false;
        }

        dispatchStorageChange(key);

        return true;
    };

    const update = (updater: (current: TValue) => TValue): boolean => {
        const current = read();
        const next = updater(current);

        return next === current ? true : write(next);
    };

    const remove = (): boolean => {
        try {
            const storage = getStorage();

            if (!storage) {
                return false;
            }

            storage.removeItem(key);
        } catch {
            return false;
        }

        dispatchStorageChange(key);

        return true;
    };

    return {
        key,
        read,
        write,
        update,
        remove,
        subscribe: (listener) => subscribeToStorageKeys([key], listener)
    };
};
import {dispatchStorageChange, subscribeToStorageKeys} from "../../../../search/utils/storage_change_event";

/*
 * A JSON value in localStorage that React can subscribe to (`useSyncExternalStore`). Other tabs are heard through the
 * native `storage` event, the current tab through RECENT_SEARCHES_CHANGED_EVENT (`storage_change_event`), which every
 * write dispatches.
 * Nothing here throws: no window (SSR), blocked storage, quota errors and broken JSON all read as the empty value.
 */

const getLocalStorage = (): Storage | null => (typeof window === "undefined" ? null : window.localStorage);

/** Keeps the items `parseItem` accepts, in order, at most `max` of them. Anything but an array gives []. */
export const parseStoredList = <TItem>(value: unknown, parseItem: (item: unknown) => TItem | null, max: number): TItem[] => {
    if (!Array.isArray(value)) {
        return [];
    }

    const items: TItem[] = [];

    for (const entry of value) {
        if (items.length >= max) {
            break;
        }

        const item = parseItem(entry);

        if (item !== null) {
            items.push(item);
        }
    }

    return items;
};

interface ILocalStorageListStoreOptions<TValue> {
    key: string;
    /** Validates the parsed JSON. Null means an unknown shape, which reads as `empty`. */
    parse: (value: unknown) => TValue | null;
    empty: TValue;
    /** Defaults to `window.localStorage`; null when there is no storage. */
    getStorage?: () => Storage | null;
}

interface ILocalStorageListStore<TValue> {
    readonly key: string;
    /** Current value. Returns the same reference while the stored string does not change, as `useSyncExternalStore` requires. */
    read: () => TValue;
    /** Stores the value and notifies same-tab subscribers. False when storage is unavailable or throws (quota, privacy mode). */
    write: (value: TValue) => boolean;
    /** Reads, applies `updater` and writes the result; an updater returning the same reference skips the write. */
    update: (updater: (current: TValue) => TValue) => boolean;
    remove: () => boolean;
    subscribe: (listener: () => void) => () => void;
}

export const createLocalStorageListStore = <TValue>(options: ILocalStorageListStoreOptions<TValue>): ILocalStorageListStore<TValue> => {
    const {key, parse, empty, getStorage = getLocalStorage} = options;

    let cachedRaw: string | null = null;
    let cachedValue: TValue = empty;

    const readRaw = (): string | null => {
        try {
            return getStorage()?.getItem(key) ?? null;
        } catch {
            return null;
        }
    };

    const read = (): TValue => {
        const raw = readRaw();

        if (raw === cachedRaw) {
            return cachedValue;
        }

        let value = empty;

        if (raw !== null) {
            try {
                value = parse(JSON.parse(raw)) ?? empty;
            } catch {
                value = empty;
            }
        }

        cachedRaw = raw;
        cachedValue = value;

        return value;
    };

    const write = (value: TValue): boolean => {
        try {
            const storage = getStorage();

            if (!storage) {
                return false;
            }

            storage.setItem(key, JSON.stringify(value));
        } catch {
            return false;
        }

        dispatchStorageChange(key);

        return true;
    };

    const update = (updater: (current: TValue) => TValue): boolean => {
        const current = read();
        const next = updater(current);

        return next === current ? true : write(next);
    };

    const remove = (): boolean => {
        try {
            const storage = getStorage();

            if (!storage) {
                return false;
            }

            storage.removeItem(key);
        } catch {
            return false;
        }

        dispatchStorageChange(key);

        return true;
    };

    return {
        key,
        read,
        write,
        update,
        remove,
        subscribe: (listener) => subscribeToStorageKeys([key], listener)
    };
};
